 const getBaseURL = () => {     const currentHost = window.location.hostname; 
    if (currentHost.startsWith('https://home.encatalogo.com/')) {
        return 'https://home.encatalogo.com/';
    } else {
        return 'https://home.encatalogo.com/';
    }
    
};

const baseURL = getBaseURL(); 

export default baseURL;


